import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { CREATE_TEAM, JOIN_TEAM } from "./constants/views";

const ModalStateContext = React.createContext();

const ModalStateProvider = ({
    children = undefined,
    initialIsSearching = false,
    initialResults = [],
    initialSearchTerm = "",
    initialView = JOIN_TEAM,
}) => {
    const [activeView, setActiveView] = React.useState(initialView);
    // Once defined, the useState default never changes.
    // Therefore we need to listen for the props change and set the new state
    useEffect(() => {
        setActiveView(initialView);
    }, [initialView]);

    const [isSearching, setIsSearching] = React.useState(initialIsSearching);
    const [results, setResults] = React.useState(initialResults);
    const [searchTerm, setSearchTerm] = React.useState(initialSearchTerm);

    const toggleActiveView = () => {
        if (activeView === JOIN_TEAM) {
            setActiveView(CREATE_TEAM);
        } else {
            setActiveView(JOIN_TEAM);
        }
    };

    return (
        <ModalStateContext.Provider
            // eslint-disable-next-line react/jsx-no-constructed-context-values
            value={{
                activeView,
                isSearching,
                results,
                searchTerm,
                setActiveView,
                setIsSearching,
                setResults,
                setSearchTerm,
                toggleActiveView,
            }}
        >
            {children}
        </ModalStateContext.Provider>
    );
};

ModalStateProvider.propTypes = {
    children: PropTypes.node,
    initialIsSearching: PropTypes.bool,
    initialResults: PropTypes.arrayOf(PropTypes.shape({})),
    initialSearchTerm: PropTypes.string,
    // Must match an enum from ./constants/views.js
    initialView: PropTypes.string,
};

export default ModalStateContext;
export { ModalStateProvider };
